import { useRef } from 'react';

import { TimeoutManager } from '../utils/taskUtils';
import useUnmountEffect from './useUnmountEffect';

function useTimeout() {
  const manager = useRef(new TimeoutManager()).current;

  useUnmountEffect(() => {
    manager.invalidate();
  });

  return manager;
}

export default useTimeout;
